/**
 * Home Section Images
 */

import { LOCALE_KO, LocaleType } from '../../../modules/i18n/config'
import { CDN_URL } from '../../../modules/vars'

export const SKELETON_LOADING_TIME = 1000
export const CDN_HOME_URL_PREFIX = `${CDN_URL}/web/ab-test/landing-home`
export const CDN_HOME_V2_URL_PREFIX = `${CDN_URL}/web/ab-test/landing-home/v2`

export const IMG_HOME_CHEVRON_DOWN_GRAY_LARGE = `${CDN_HOME_URL_PREFIX}/chevron-down-gray.svg`
export const IMG_HOME_CHEVRON_CIRLCE_OUTLINE_LEFT = `${CDN_HOME_URL_PREFIX}/chevron-circle-outline-left.svg`
export const IMG_HOME_CHEVRON_CIRLCE_OUTLINE_RIGHT = `${CDN_HOME_URL_PREFIX}/chevron-circle-outline-right.svg`

export const IMG_HOME_TUTOR_UNIV_LOGO_YALE = `${CDN_HOME_URL_PREFIX}/yale-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_NORTHWESTERN = `${CDN_HOME_URL_PREFIX}/northwestern-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_HARVARD = `${CDN_HOME_URL_PREFIX}/harvard-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_DUKE = `${CDN_HOME_URL_PREFIX}/duke-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_CORNELL = `${CDN_HOME_URL_PREFIX}/cornell-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_CAMBRIDGE = `${CDN_HOME_URL_PREFIX}/cambridge-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_BROWN = `${CDN_HOME_URL_PREFIX}/brown-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_PENN = `${CDN_HOME_URL_PREFIX}/penn-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_DARTMOUTH = `${CDN_HOME_URL_PREFIX}/dartmouth-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_OXFORD = `${CDN_HOME_URL_PREFIX}/oxford-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_NYU = `${CDN_HOME_URL_PREFIX}/nyu-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_PRINCETON = `${CDN_HOME_URL_PREFIX}/princeton-logo.svg`
export const IMG_HOME_TUTOR_UNIV_LOGO_COLUMBIA = `${CDN_HOME_URL_PREFIX}/columbia-logo.svg`

export const IMG_HOME_PRICING_CARD_LEFT = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_URL_PREFIX}/section-pricing-one-v2.webp`
    : `${CDN_HOME_URL_PREFIX}/section-pricing-one-v2-en.png`
export const IMG_HOME_PRICING_CARD_MID = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_URL_PREFIX}/section-pricing-two-v4.webp`
    : `${CDN_HOME_URL_PREFIX}/section-pricing-two-v4-en.png`
export const IMG_HOME_PRICING_CARD_RIGHT = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_URL_PREFIX}/section-pricing-three-v2.webp`
    : `${CDN_HOME_URL_PREFIX}/section-pricing-three-v2-en.png`

export const IMG_HOME_SECTION_ICON_REVIEW = `${CDN_HOME_URL_PREFIX}/section-chat.svg`
export const IMG_HOME_SECTION_ICON_TUTOR = `${CDN_HOME_URL_PREFIX}/section-tutor.svg`
export const IMG_HOME_SECTION_ICON_MATERIAL = `${CDN_HOME_URL_PREFIX}/section-material.svg`
export const IMG_HOME_SECTION_ICON_SYSTEM = `${CDN_HOME_URL_PREFIX}/section-review.svg`
export const IMG_HOME_SECTION_ICON_PRICING = `${CDN_HOME_URL_PREFIX}/section-pricing.svg`

export const IMG_HOME_ICON_LANGUAGE = `${CDN_HOME_URL_PREFIX}/globe.svg`

export const IMG_FOOTER_ICON_YOUTUBE = `${CDN_HOME_URL_PREFIX}/youtube-logo.webp`
export const IMG_FOOTER_ICON_FACEBOOK = `${CDN_HOME_URL_PREFIX}/fb-logo.webp`
export const IMG_FOOTER_ICON_INSTA = `${CDN_HOME_URL_PREFIX}/insta-logo.webp`

export const IMG_HOME_COMPANY_ROW_ONE = `${CDN_HOME_URL_PREFIX}/section-company-row-one.png`
export const IMG_HOME_COMPANY_ROW_TWO = `${CDN_HOME_URL_PREFIX}/section-company-row-two.png`
export const IMG_HOME_COMPANY_ROW_THREE = `${CDN_HOME_URL_PREFIX}/section-company-row-three.png`

export const IMG_HOME_SYSTEM_POPUP_DOCS = `${CDN_HOME_URL_PREFIX}/system-docs-img.png`
export const IMG_HOME_SYSTEM_POPUP_FEEDBACK = `${CDN_HOME_URL_PREFIX}/system-feedback-img.png`
export const IMG_HOME_SYSTEM_POPUP_ANALYSIS = `${CDN_HOME_URL_PREFIX}/system-analysis-img.png`

export const VID_HOME_SYSTEM_DOCS_MP4 = `${CDN_HOME_URL_PREFIX}/home-system-video.mp4`
export const VID_HOME_SYSTEM_DOCS_WEBM = `${CDN_HOME_URL_PREFIX}/home-system-video.webm`

/**
 * HOME SECTION V2 IMAGE
 */

export const IMG_HOME_V2_TUTOR_SECTION_IMAGE_1 = `${CDN_HOME_V2_URL_PREFIX}/tutor-img-1.webp`

export const IMG_HOME_V2_TUTOR_SECTION_IMAGE_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/tutor-img-2-v2.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/tutor-img-2-v2-en.webp`

export const IMG_HOME_V2_TUTOR_SECTION_IMAGE_3 = (locale: LocaleType) =>
  locale === LOCALE_KO ? `${CDN_HOME_V2_URL_PREFIX}/tutor-img-3.webp` : `${CDN_HOME_V2_URL_PREFIX}/tutor-img-3-en.webp`

export const IMG_HOME_V2_TUTOR_SECTION_IMAGE_4 = (locale: LocaleType) =>
  locale === LOCALE_KO ? `${CDN_HOME_V2_URL_PREFIX}/tutor-img-4.webp` : `${CDN_HOME_V2_URL_PREFIX}/tutor-img-4-en.webp`

export const IMG_HOME_SECTION_ICON_LESSON = `${CDN_HOME_URL_PREFIX}/calendar.svg`
export const IMG_HOME_SECTION_ICON_SYSTEM_V2 = `${CDN_HOME_URL_PREFIX}/pen.svg`
export const IMG_HOME_SECTION_ICON_CONTENT = `${CDN_HOME_URL_PREFIX}/mail.svg`
export const IMG_HOME_SECTION_ICON_REVIEW_V2 = `${CDN_HOME_URL_PREFIX}/chat.svg`
export const IMG_HOME_SECTION_ICON_PROMOTION = `${CDN_HOME_URL_PREFIX}/coupon.svg`

export const IMG_HOME_SECTION_ICON_PLAY = `${CDN_HOME_URL_PREFIX}/play.svg`
export const IMG_HOME_SECTION_ICON_PAUSE = `${CDN_HOME_URL_PREFIX}/pause.svg`

export const IMG_HOME_LESSON_IMAGE_1 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/lesson-img-1.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/lesson-img-1-en.webp`

export const IMG_HOME_LESSON_IMAGE_2 = `${CDN_HOME_V2_URL_PREFIX}/lesson-img-2.webp`

export const IMG_HOME_LESSON_IMAGE_3_DESKTOP = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135584126_img_tutorprofile_export_desktop_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135598437_img_tutorprofile_export_desktop_en.webp`

export const IMG_HOME_LESSON_IMAGE_3_MOBILE = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135607578_img_tutorprofile_export_mo_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135616547_img_tutorprofile_export_mo_en.webp`

export const IMG_HOME_LESSON_IMAGE_4_DESKTOP = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135736889_img_lessonstyle_export_web_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135748859_img_lessonstyle_export_web_en.webp`

export const IMG_HOME_LESSON_IMAGE_4_MOBILE = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135757686_img_lessonstyle_export_mo_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715135766446_img_lessonstyle_export_mo_en.webp`

export const IMG_HOME_V2_SYSTEM_IMAGE_1 = `${CDN_HOME_V2_URL_PREFIX}/system-img-1.webp`
export const IMG_HOME_V2_SYSTEM_IMAGE_2 = `${CDN_HOME_V2_URL_PREFIX}/system-img-2.webp`
export const IMG_HOME_V2_SYSTEM_IMAGE_3 = `${CDN_HOME_V2_URL_PREFIX}/system-img-3.webp`
export const IMG_HOME_V2_SYSTEM_IMAGE_4 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715148456376_img_aianalysisexport_mo_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715148475936_img_aianalysisexport_mo.webp`
export const IMG_HOME_V2_SYSTEM_IMAGE_5 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/system-img-5-v2.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/system-img-5-v2-en.webp`
export const IMG_HOME_V2_SYSTEM_IMAGE_6 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715148942218_img_feedback_export_mo_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715148952432_img_feedback_export_mo_en.webp`

export const IMG_HOME_CHEVRON_DOWN_BOLD = `${CDN_HOME_URL_PREFIX}/chevron-bold.png`

export const IMG_HOME_CONTENTS_IMAGE_1_1 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/content-img-1-1.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/content-img-1-1-en.webp`
export const IMG_HOME_CONTENTS_IMAGE_1_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/content-img-1-2.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/content-img-1-2-en.webp`
export const IMG_HOME_CONTENTS_IMAGE_1_3 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/content-img-1-3.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/content-img-1-3-en.webp`
export const IMG_HOME_CONTENTS_IMAGE_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715166376829_img_daily_export_mo_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715166391109_img_daily_export_mo_en.webp`

export const VIDEO_HOME_REVIEW_ONE_MP4 = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-one.mp4`
export const VIDEO_HOME_REVIEW_TWO_MP4 = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-two.mp4`
export const VIDEO_HOME_REVIEW_THREE_MP4 = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-three.mp4`
export const VIDEO_HOME_REVIEW_FOUR_MP4 = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-four.mp4`

export const VIDEO_HOME_REVIEW_ONE_WEBM = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-one.webm`
export const VIDEO_HOME_REVIEW_TWO_WEBM = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-two.webm`
export const VIDEO_HOME_REVIEW_THREE_WEBM = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-three.webm`
export const VIDEO_HOME_REVIEW_FOUR_WEBM = `${CDN_HOME_V2_URL_PREFIX}/video/review-video-four.webm`

export const IMG_HOME_PROMOTION_1 = `${CDN_HOME_V2_URL_PREFIX}/promotion-discount.webp`
export const IMG_HOME_PROMOTION_2 = `${CDN_HOME_V2_URL_PREFIX}/promotion-study-club.webp`
export const IMG_HOME_PROMOTION_3 = `${CDN_HOME_V2_URL_PREFIX}/promotion-challenge.webp`

export const IMG_HOME_DESKTOP_TUTOR_1 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/desktop/tutor-img-1.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/tutor-img-1-en.webp`

export const IMG_HOME_DESKTOP_TUTOR_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/desktop/tutor-img-2.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/tutor-img-2-en.webp`

export const IMG_HOME_DESKTOP_TUTOR_3 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/desktop/tutor-img-3.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/tutor-img-3-en.webp`

export const IMG_HOME_DESKTOP_SYSTEM_1 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715148266204_img_aianalysisexport_web_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715148315119_img_aianalysisexport_web_en.webp`
export const IMG_HOME_DESKTOP_SYSTEM_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/desktop/system-img-2.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/system-img-2-en.webp`
export const IMG_HOME_DESKTOP_SYSTEM_3 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715166864808_img_feedback_export_web_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715166873612_img_feedback_export_web_en.webp`

export const IMG_HOME_DESKTOP_CONTENT_1_1 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/desktop/content-img-1-1.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/content-img-1-1-en.webp`
export const IMG_HOME_DESKTOP_CONTENT_1_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/desktop/content-img-1-2.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/content-img-1-2-en.webp`
export const IMG_HOME_DESKTOP_CONTENT_1_3 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/desktop/content-img-1-3.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/content-img-1-3-en.webp`
export const IMG_HOME_DESKTOP_CONTENT_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715146523348_img_daily_export_web_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715146533953_img_daily_export_web_en.webp`

export const IMG_HOME_CONTENT_AI_TUTOR_DESKTOP = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715146962649_img_aispeakingpartner_export_web_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715147007920_img_aispeakingpartner_export_web_en.webp`
export const IMG_HOME_CONTENT_AI_TUTOR_MOBILE = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `https://d38emex6h5e12i.cloudfront.net/2024-image/1715166415917_img_aispeakingpartner_export_mo_kr.webp`
    : `https://d38emex6h5e12i.cloudfront.net/2024-image/1715166431322_img_aispeakingpartner_export_mo_en.webp`

export const IMG_HOME_DESKTOP_COMPANY_ROW_ONE = `${CDN_HOME_V2_URL_PREFIX}/desktop/company-list-1.webp`
export const IMG_HOME_DESKTOP_COMPANY_ROW_TWO = `${CDN_HOME_V2_URL_PREFIX}/desktop/company-list-2.webp`
export const IMG_HOME_DESKTOP_COMPANY_ROW_THREE = `${CDN_HOME_V2_URL_PREFIX}/desktop/company-list-3.webp`

export const IMG_HOME_DESKTOP_ICON_CHEVRON_CIRCLE_LEFT = `${CDN_HOME_URL_PREFIX}/circle-chevron-left.svg`
export const IMG_HOME_DESKTOP_ICON_CHEVRON_CIRCLE_RIGHT = `${CDN_HOME_URL_PREFIX}/circle-chevron-right.svg`

export const IMG_HOME_DESKTOP_PRICING_1 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/section-pricing-desktop-1.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/section-pricing-desktop-1-en.webp`
export const IMG_HOME_DESKTOP_PRICING_2 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/section-pricing-desktop-2-v3.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/section-pricing-desktop-2-v3-en.webp`
export const IMG_HOME_DESKTOP_PRICING_3 = (locale: LocaleType) =>
  locale === LOCALE_KO
    ? `${CDN_HOME_V2_URL_PREFIX}/section-pricing-desktop-3-v3.webp`
    : `${CDN_HOME_V2_URL_PREFIX}/desktop/section-pricing-desktop-3-v3-en.webp`

export const IMG_HOME_KCAB_LOGO = (locale: LocaleType) =>
  locale === LOCALE_KO ? `${CDN_HOME_URL_PREFIX}/kcab.svg` : `${CDN_HOME_URL_PREFIX}/kcab-en.svg`

/**
 * BODY V2 IMAGE
 */

export const IMG_ENGLISH_TUTOR_DESKTOP_HERO = `${CDN_HOME_V2_URL_PREFIX}/english-tutor-desktop-hero.webp`
export const IMG_ENGLISH_MATERIAL_DESKTOP_HERO = `${CDN_HOME_V2_URL_PREFIX}/english-material-desktop-hero.webp`
